import * as React from 'react';

const SwitchViewContext = React.createContext({
  activeViewId: null,
  shouldShowDefault: null,
  activateView: null,
  addView: null,
});

export default SwitchViewContext;
